import React from 'react';

export type Props = {
  className?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};
export const FacebookCircleV2 = React.memo((props: Props) => {
  return (
    <svg
      width={props.width || 40}
      height={props.height || 40}
      className={props.className}
      onClick={props.onClick}
      viewBox='0 0 80 80'
    >
      <circle cx='40' cy='40' r='39.78' fill='#fff'/>
      <path d='M40,10.23c-16.41,0-29.77,13.35-29.77,29.77s13.35,29.77,29.77,29.77,29.77-13.35,29.77-29.77-13.35-29.77-29.77-29.77ZM42.17,64.16v-15.27h6.78c.7,0,1.3-.53,1.38-1.23l.52-4.19c.1-.83-.54-1.57-1.38-1.57h-7.31v-6.11c0-1.93,1.56-3.49,3.48-3.49h4.35c.48,0,.87-.39.87-.87v-5.24c0-.48-.39-.87-.87-.87h-6.09c-4.8,0-8.7,3.91-8.7,8.73v7.86h-5.22c-.48,0-.87.39-.87.87v5.24c0,.48.39.87.87.87h5.22v14.89c-11.1-2.23-19.48-12.05-19.48-23.79,0-13.38,10.89-24.27,24.27-24.27s24.27,10.89,24.27,24.27c0,12.65-9.73,23.06-22.09,24.16Z' fill='#4d3386'/>
    </svg>
  );
});

FacebookCircleV2.displayName = 'FacebookCircleV2';
